package com.bikompanion.ui.strings

val HiBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "फिर से कोशिश करें"
    override val actionClose = "बंद करें"
    override val actionSubmit = "भेजें"
    override val detailsLabel = "विवरण"
    override val detailsShow = "विवरण दिखाएं"
    override val detailsHide = "विवरण छिपाएं"
    override val actionGetDirections = "दिशा-निर्देश पाएं"
    override val actionShareStation = "स्टेशन साझा करें"
    override val linkCopied = "लिंक कॉपी किया गया"
    override val locateShow = "मेरी लोकेशन दिखाएं"
    override val locateFollowHeading = "मेरी दिशा के साथ चलें"
    override val locateStopFollowing = "मुझे फ़ॉलो करना बंद करें"
    override val settingsTitle = "सेटिंग"
    override val actionBack = "वापस"
    override val settingsAppearance = "दिखावट"
    override val settingsLanguage = "भाषा"
    override val languageSystem = "सिस्टम डिफ़ॉल्ट"
    override val themeSystem = "सिस्टम"
    override val themeLight = "हल्की"
    override val themeDark = "गहरी"
    override val settingsNotifications = "सूचनाएँ"
    override val stationAlerts = "स्टेशन अलर्ट"
    override val notificationsOn = "चालू: देखे जा रहे स्टेशन पर बाइक मिलते ही आपको पता चलेगा"
    override val notificationsOff = "बंद: देखे जा रहे स्टेशन आपको सूचित नहीं कर सकते"
    override val notificationsBlocked = "अवरुद्ध: अपने ब्राउज़र की साइट सेटिंग में सूचनाओं की अनुमति दें"
    override val actionManage = "प्रबंधित करें"
    override val actionTurnOn = "चालू करें"
    override val settingsSupport = "सहायता"
    override val sendFeedback = "फ़ीडबैक भेजें"
    override val sendFeedbackDescription = "किसी समस्या या स्टेशन की गलत जानकारी के बारे में बताएँ"
    override val shareApp = "ऐप साझा करें"
    override val settingsAbout = "जानकारी"
    override val aboutApp = "Bikompanion के बारे में"
    override val aboutDevelopedBy = "Tiago Araujo द्वारा विकसित"
    override val aboutDataSources = "डेटा स्रोत"
    override val sourceCityBikesDescription = "दुनिया भर के बाइक-शेयर नेटवर्क"
    override val sourceGbfsTitle = "ऑपरेटरों के GBFS फ़ीड"
    override val sourceGbfsDescription = "बाइक-शेयर ऑपरेटरों से स्टेशन का लाइव डेटा"
    override val sourceOsmTitle = "OpenStreetMap योगदानकर्ता"
    override val sourceOsmDescription = "बाइक पार्किंग और मानचित्र डेटा"
    override val sourceCartoDescription = "मानचित्र टाइलें"
    override val aboutLegal = "कानूनी"
    override val licensesTitle = "ओपन सोर्स लाइसेंस"
    override val privacyPolicy = "गोपनीयता नीति"
    override val deleteRatings = "मेरी रेटिंग हटाएँ"
    override val deleteRatingsDescription = "आपकी गुमनाम आईडी हमें ईमेल करता है ताकि हम उन्हें हटा सकें"
    override val licensesLoadFailed = "लाइसेंस सूची लोड नहीं हो सकी"
    override val aboutVersion = { version: String -> "संस्करण $version" }
    override val issueFlatTire = "टायर पंक्चर"
    override val issueFrontBrake = "आगे का ब्रेक काम नहीं कर रहा"
    override val issueRearBrake = "पीछे का ब्रेक काम नहीं कर रहा"
    override val issueChain = "चेन फिसल रही है"
    override val issueGears = "गियर नहीं बदल रहे"
    override val issueSeat = "सीट खराब या गायब"
    override val issueLights = "लाइटें काम नहीं कर रहीं"
    override val issueLockOrBasket = "लॉक या टोकरी खराब"
    override val issueFrame = "फ्रेम खराब"
    override val issueMotor = "इलेक्ट्रिक मोटर काम नहीं कर रही"
    override val issueBattery = "बैटरी चार्ज नहीं हो रही"
    override val issueOther = "अन्य"
    override val networksLoadFailed = "बाइक नेटवर्क लोड नहीं हो सके। अपना कनेक्शन जांचें।"
    override val parkingLoadFailed = "बाइक पार्किंग लोड नहीं हो सकी"
    override val parkingLoading = "बाइक पार्किंग खोजी जा रही है…"
    override val stationsLoading = "बाइक स्टेशन लोड हो रहे हैं…"
    override val noNetworkHereTitle = "यहाँ कोई बाइक शेयर नहीं है"
    override val noNetworkHereHint = "सबसे नज़दीकी नेटवर्क देखने के लिए ज़ूम आउट करें"
    override val installTitle = "Bikompanion इंस्टॉल करें"
    override val installHintIos = "शेयर पर टैप करें, फिर होम स्क्रीन पर जोड़ें चुनें।"
    override val installHintAndroid = "Google Play से ऐप पाएं।"
    override val actionInstall = "इंस्टॉल करें"
    override val parkingTypeStands = "बाइक स्टैंड"
    override val parkingTypeShed = "बाइक शेड"
    override val parkingTypeLockers = "बाइक लॉकर"
    override val parkingTypeBuilding = "बाइक भवन"
    override val parkingTypeOther = "बाइक पार्किंग"
    override val fieldAddress = "पता"
    override val fieldCovered = "ढका हुआ"
    override val fieldYes = "हाँ"
    override val fieldNo = "नहीं"
    override val fieldId = "आईडी"
    override val fieldStationId = "स्टेशन आईडी"
    override val fieldCoordinates = "निर्देशांक"
    override val fieldCapacity = "क्षमता"
    override val fieldNetwork = "नेटवर्क"
    override val fieldName = "नाम"
    override val fieldCity = "शहर"
    override val fieldCountry = "देश"
    override val fieldCompany = "कंपनी"
    override val fieldLicense = "लाइसेंस"
    override val fieldLicenseUrl = "लाइसेंस URL"
    override val availabilityBikes = "बाइक"
    override val availabilityElectric = "इलेक्ट्रिक"
    override val availabilityEmpty = "खाली"
    override val bicingNextPickup = { p0: String -> "अगला Bicing पिकअप $p0 में" }
    override val rateTitle = "बाइक जांचें या रेट करें"
    override val rateFindingNetworks = "आपके आसपास के बाइक नेटवर्क खोजे जा रहे हैं…"
    override val rateWhatsWrong = "इसमें क्या खराबी है?"
    override val rateBikeNumber = "बाइक नंबर"
    override val rateElectricBike = "इलेक्ट्रिक बाइक"
    override val rateVoteBad = "खराब"
    override val rateVoteGood = "अच्छी"
    override val rateWhichNetwork = "यह बाइक किस नेटवर्क की है?"
    override val refreshRateLimited = "अनुरोध सीमा पूरी हुई — अपने आप फिर कोशिश हो रही है"
    override val refreshFailed = "अपडेट नहीं हो सका"
    override val refreshNextUpdate = { p0: Int -> "अगला अपडेट $p0 से. में" }
    override val refreshUpdating = "अपडेट हो रहा है…"
    override val dataNone = "अभी कोई डेटा नहीं"
    override val dataAgeJustNow = "अभी-अभी का डेटा दिख रहा है"
    override val dataAgeMinutes = { p0: Int -> "$p0 मिनट पहले का डेटा दिख रहा है" }
    override val dataAgeHours = { p0: Int -> "$p0 घंटे पहले का डेटा दिख रहा है" }
    override val dataAgeDays = { p0: Int -> "$p0 दिन पहले का डेटा दिख रहा है" }
    override val actionOpenOperator = { p0: String -> "$p0 खोलें" }
    override val watchNormal = "सामान्य बाइक पर नज़र रखें"
    override val watchElectric = "इलेक्ट्रिक बाइक पर नज़र रखें"
    override val watchInstallNormal = "सामान्य बाइक पर नज़र रखने के लिए ऐप इंस्टॉल करें"
    override val watchInstallElectric = "इलेक्ट्रिक बाइक पर नज़र रखने के लिए ऐप इंस्टॉल करें"
    override val watchStopNormal = "सामान्य बाइक पर नज़र रखना बंद करें"
    override val watchStopElectric = "इलेक्ट्रिक बाइक पर नज़र रखना बंद करें"
    override val actionCheckRateBike = "बाइक जांचें / रेट करें"
    override val layerStations = "स्टेशन"
    override val layerParking = "बाइक पार्किंग"
    override val mapLabelBikes = { p0: Int -> "$p0 बाइक" }
    override val mapLabelEbikes = { p0: Int -> "$p0 ई-बाइक" }
    override val mapLabelFree = { p0: Int -> "$p0 खाली" }
    override val scoreHeadline = { p0: String, p1: String -> "बाइक $p0 · $p1" }
    override val scoreNoRatings = "अभी कोई रेटिंग नहीं — पहली रेटिंग आप दे सकते हैं।"
    override val scoreLooksGood = "अच्छी लग रही है।"
    override val scoreHasProblems = "सवारों को इसमें दिक्कत आई है।"
    override val scoreMixed = "मिली-जुली राय।"
    override val ratingNetworkRequired = "पहले चुनें कि यह बाइक किस नेटवर्क की है।"
    override val ratingThanks = { p0: String -> "बाइक $p0 को रेट करने के लिए धन्यवाद!" }
    override val ratingCooldown = { p0: Int -> "आपने हाल ही में इस बाइक को रेट किया है। $p0 मिनट बाद फिर कोशिश करें।" }
    override val ratingQueued = "सहेजा गया — आपके ऑनलाइन होते ही हम इसे भेज देंगे।"
    override val ratingInvalidBike = "यह बाइक नंबर इस नेटवर्क के लिए मान्य नहीं है।"
    override val ratingRejected = "वह रेटिंग सहेजी नहीं जा सकी। कृपया बाद में फिर कोशिश करें।"
    override val notificationFoundTitle = "बाइक उपलब्ध है"
    override val notificationFoundNormal = { p0: String -> "$p0 पर सामान्य बाइक उपलब्ध है" }
    override val notificationFoundElectric = { p0: String -> "$p0 पर इलेक्ट्रिक बाइक उपलब्ध है" }
    override val notificationExpiredTitle = "स्टेशन निगरानी समाप्त"
    override val notificationExpiredNormal = { p0: String -> "30 मिनट बाद $p0 पर सामान्य बाइक की निगरानी बंद कर दी गई" }
    override val notificationExpiredElectric = { p0: String -> "30 मिनट बाद $p0 पर इलेक्ट्रिक बाइक की निगरानी बंद कर दी गई" }
    override val channelWatchAlertsName = "स्टेशन निगरानी अलर्ट"
    override val channelWatchAlertsDescription = "बाइक की उपलब्धता और स्टेशन निगरानी की जानकारी"
    override val channelBackgroundWatchName = "बैकग्राउंड में स्टेशन निगरानी"
    override val notificationWatchingTitle = "बाइक स्टेशनों की निगरानी हो रही है"
    override val notificationWatchingText = "चुने गए स्टेशनों की बैकग्राउंड में निगरानी हो रही है"
    override val scoreFewRatings = { count: Int -> "अब तक सिर्फ़ $count रेटिंग।" }
    override val scorePositiveRides = { percent: Int, count: Int ->
        singularOrPlural(
            count,
            "पिछली $count सवारी में $percent% सकारात्मक",
            "पिछली $count सवारियों में $percent% सकारात्मक",
        )
    }
}
